/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Never_SeenInputs */

const vi_print_admin_never_seen = /** @type {(inputs: Print_Admin_Never_SeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa từng kết nối`)
};

/**

* @param {Print_Admin_Never_SeenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_never_seen = /** @type {((inputs?: Print_Admin_Never_SeenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Never_SeenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_never_seen(inputs)
});